/**
 * Theme Configuration Variables
 * Global variables for the theme
 */

// Shop and route configuration
window.shopUrl = '';
window.routes = {
  cart_add_url: '' || '/cart/add.js',
  cart_change_url: '' || '/cart/change.js',
  cart_update_url: '' || '/cart/update.js',
  cart_url: '' || '/cart',
  predictive_search_url: '' || '/search/suggest'
};

// Fallback for empty routes
if (!window.routes.cart_add_url || window.routes.cart_add_url === '') {
  window.routes.cart_add_url = '/cart/add.js';
}
if (!window.routes.cart_change_url || window.routes.cart_change_url === '') {
  window.routes.cart_change_url = '/cart/change.js';
}
if (!window.routes.cart_update_url || window.routes.cart_update_url === '') {
  window.routes.cart_update_url = '/cart/update.js';
}
if (!window.routes.cart_url || window.routes.cart_url === '') {
  window.routes.cart_url = '/cart';
}
if (!window.routes.predictive_search_url || window.routes.predictive_search_url === '') {
  window.routes.predictive_search_url = '/search/suggest';
}

// Cart strings
window.cartStrings = {
  error: `Sepetiniz güncellenirken bir hata oluştu. Lütfen tekrar deneyin.`,
  quantityError: `Sepetinize bu üründen yalnızca [quantity] adet ekleyebilirsiniz.`
};

// Variant strings
window.variantStrings = {
  addToCart: `Sepete ekle`,
  soldOut: `Stoğa Gelince Haber Ver`,
  unavailable: `Kullanım dışı`,
  unavailable_with_option: `[value] - Kullanılamıyor`,
};

// Quick order list strings
window.quickOrderListStrings = {
  itemsAdded: `[quantity] adet ürün eklendi`,
  itemAdded: `[quantity] adet ürün eklendi`,
  itemsRemoved: `[quantity] adet ürün kaldırıldı`,
  itemRemoved: `[quantity] adet ürün kaldırıldı`,
  viewCart: `Sepeti Görüntüle`,
  each: `[money]/ adet`,
};

// Accessibility strings
window.accessibilityStrings = {
  imageAvailable: `Görsel [index] artık galeri görüntüleyicide kullanılabilir`,
  shareSuccess: `Bağlantı panoya kopyalandı`,
  pauseSlideshow: `Slayt gösterisini duraklat`,
  playSlideshow: `Slayt gösterisini oynat`,
  recipientFormExpanded: `Hediye kartı alıcı formu genişletildi`,
  recipientFormCollapsed: `Hediye kartı alıcı formu daraltıldı`,
};

// Ensure fetchConfig function is available globally before other scripts load
if (typeof fetchConfig === 'undefined') {
  window.fetchConfig = function(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  };
}

// Theme configuration loaded successfully